import tinycolor from 'tinycolor2';

const COLORS_WITH_BORDER = ['#ffffff'];
export const isDarkModeEnabled = () =>
  document.body.getAttribute('data-theme') === 'dark';
export const mixColorForTheme = (
  color: string,
  weight: number = 90,
  forceDark?: boolean
) => {
  const mixedColor = tinycolor.mix(
    color,
    forceDark || isDarkModeEnabled() ? '#21282e' : 'white',
    weight
  );
  return mixedColor.toRgbString();
};

export const colorRequiresBorder = (color: string): boolean =>
  COLORS_WITH_BORDER.some(colorWithBorder =>
    tinycolor.equals(colorWithBorder, color)
  );

// varName must be in format '--var-name'
// (Exported for mocking purposes)
// Return for this could be 'rgb(x,y,z)' '51, 51, 51'
export const getCssValue = (varName: string): string => {
  return getComputedStyle(document.body).getPropertyValue(varName);
};

// Replaces '--var-name' or 'var(--var-name)' with CSS variable value
export const decodeCssVars = (vars: string): string => {
  const cssVarRegex = /(?:var\()?--[\w-]+(?:\))?/g;
  const cssVars = vars.match(cssVarRegex) || [];
  const resolvedVarsMap = new Map<string, string>();

  cssVars.forEach(varName => {
    if (!resolvedVarsMap.has(varName)) {
      const cleanVarName = varName.replace(/^var\(/, '').replace(/\)$/, '');
      const resolvedValue = getCssValue(cleanVarName);
      resolvedVarsMap.set(varName, resolvedValue);
    }
  });
  let result = vars;
  resolvedVarsMap.forEach((resolvedValue, varName) => {
    if (resolvedValue) {
      const varRegex = new RegExp(
        varName.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'),
        'g'
      );
      result = result.replace(varRegex, resolvedValue);
    }
  });

  return result;
};

export const decodeColor = (_color: string): string => {
  let color = _color;
  if (_color.includes('--')) {
    color = decodeCssVars(_color);
  }
  // Handle alpha
  if (color.startsWith('rgba(')) {
    // Copy alpha behavior of old ColorPicker
    const alpha = 1 - tinycolor(color).getAlpha();
    const hex = tinycolor(color).toHex();
    const mixed = tinycolor.mix(tinycolor(hex), '#ffffff', alpha * 100);
    return mixed.toHexString();
  }
  return tinycolor(color).toHexString();
};
